import React, { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'

import IconButton from '@components/Buttons/IconButton'
import TeamLogo from '@components/LayoutTabs/SubsectionReusableComponents/TeamLogo'
import { SportEntity } from '@utils/entities'

interface FollowMyTeamSportEntityProps {
  sportEntity: SportEntity
  isFollowMyTeamEnabled: boolean
  isFollowing: boolean
  onToggleFollowing: (sportEntity: SportEntity) => void
  className?: string
}

const StyledListSportEntity = styled.li`
  ${({
    theme: {
      spacing: { spacing8 },
      colors: { strokeWeak },
    },
  }) => css`
    padding: ${spacing8} 0;
    border-bottom: 1px solid ${strokeWeak};
    display: flex;
    gap: ${spacing8};
    align-items: center;
  `}
`
const StyledListSportEntityText = styled.div`
  ${({
    theme: {
      colors: { textDefault },
      typography: {
        subheads: {
          small1: { bundledCSS: small1SubheadCSS },
        },
      },
    },
  }) => css`
    color: ${textDefault};
    ${small1SubheadCSS};
  `}
`

const StyledIcons = styled.div<{ isFollowMyTeamEnabled: boolean }>`
  ${({ isFollowMyTeamEnabled }) => css`
    display: ${!isFollowMyTeamEnabled ? 'none' : 'flex'};
    margin-left: auto;
  `}
`

const FollowMyTeamSportEntity: FunctionComponent<
  FollowMyTeamSportEntityProps
> = ({
  sportEntity,
  isFollowMyTeamEnabled,
  isFollowing,
  onToggleFollowing,
  className,
}) => {
  const handleToggleFollowing = () => {
    onToggleFollowing(sportEntity)
  }

  return (
    <StyledListSportEntity key={sportEntity.entityId} className={className}>
      <TeamLogo
        name={sportEntity.image?.alt}
        url={sportEntity.image?.src}
        size={40}
      />
      <StyledListSportEntityText>{sportEntity.title}</StyledListSportEntityText>
      <StyledIcons isFollowMyTeamEnabled={isFollowMyTeamEnabled}>
        {/* <IconButton
          iconName="bell-settings-solid"
          ariaLabel="notification settings"
          iconSize={24}
          onClick={() => {}}
        /> */}
        <IconButton
          iconName={isFollowing ? 'check-circle-solid' : 'plus-circle'}
          ariaLabel={isFollowing ? 'unfollow' : 'follow'}
          iconSize={24}
          onClick={handleToggleFollowing}
        />
      </StyledIcons>
    </StyledListSportEntity>
  )
}

export default FollowMyTeamSportEntity
